<template>
    <rkm-overlay>
        <template v-if="[enums.setorTipo.CONSULTORIO].includes(centroCusto.setor.tipoId)">
            <rkm-layout-body title="Atendimento">
                <template v-slot:actions>
                    <rkm-button
                        @click="exit"
                        color="danger"
                    >
                        Sair
                    </rkm-button>

                    <rkm-button
                        :disabled="disableSaveDraftButton"
                        @click="$refs.Form.save(true)"
                        color="info"
                    >
                        Salvar rascunho
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>
                <template>
                    <div class="patient-header" v-if="!!form">
                        <div class="patient-main-card">
                            <div class="patient-top">
                                <div class="patient-content">
                                    <div class="patient-identity">
                                        <div class="patient-name-line">
                                            <template v-if="form.paciente.nomeSocial">
                                                <h2 class="patient-name">
                                                    {{ form.paciente.nomeSocial }}
                                                </h2>

                                                <span class="badge-social">
                                                    Nome social
                                                </span>

                                                <span class="patient-real-name">
                                                    {{ form.paciente.nome }}
                                                </span>
                                            </template>

                                            <template v-else>
                                                <h2 class="patient-name">
                                                    {{ form.paciente.nome }}
                                                </h2>
                                            </template>

                                            <div class="patient-tags">
                                                <span class="info-chip">
                                                    {{ form.paciente.sexoDescricao }}
                                                </span>

                                                <span class="info-chip">
                                                    {{ form.paciente.racaCorDescricao }}
                                                </span>

                                                <span
                                                    class="info-chip"
                                                    v-if="form.paciente.idadeFormatada"
                                                >
                                                    {{ form.paciente.idadeFormatada }}
                                                </span>

                                                <span
                                                    class="info-chip"
                                                    v-if="form.paciente.dataNascimento"
                                                >
                                                    DATA NASCIMENTO: {{ form.paciente.dataNascimento }}   
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="patient-grid">

                                        <div class="info-block">
                                            <label>Nome da mãe</label>
                                            <span>
                                                {{ form.paciente.nomeMae || '-' }}
                                            </span>
                                        </div>

                                        <div class="info-block">
                                            <label>Prontuário</label>
                                            <span>
                                                {{ form.paciente.prontuario || '-' }}
                                            </span>
                                        </div>

                                        <div class="info-block">
                                            <label>CPF</label>
                                            <span>
                                                {{ form.paciente.cpf || '-' }}
                                            </span>
                                        </div>

                                        <div class="info-block">
                                            <label>CNS</label>
                                            <span>
                                                {{ form.paciente.cns || '-' }}
                                            </span>
                                        </div>

                                        <div class="info-block">
                                            <label>Telefone</label>
                                            <div>
                                                <template v-if="form.paciente.telefoneNumero">
                                                    <rkm-button
                                                        @click="$refs.ModalPacienteTelefone.open(form.paciente)"
                                                        class="sub-title-link"
                                                        color="link"
                                                        title="Atualizar telefone"
                                                    >
                                                        {{ form.paciente.telefoneNumero }}
                                                    </rkm-button>

                                                    <small
                                                        v-if="form.paciente.telefoneNumero.length === 15"
                                                    >
                                                        SMS:
                                                        {{ form.paciente.telefoneAutorizaSms ? 'Sim' : 'Não' }}
                                                    </small>
                                                </template>

                                                <template v-else>
                                                    -
                                                </template>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="health-flags"
                                        v-if="form.acompanhamentosSaude.length > 0"
                                    >
                                        <span class="health-title">
                                            Acompanhamentos:
                                        </span>

                                        <span
                                            v-for="(acompanhamento, index) in form.acompanhamentosSaude"
                                            :key="index"
                                            :class="`health-badge acompanhamento-${acompanhamento.value}`"
                                        >
                                            {{ acompanhamento.text }}
                                        </span>
                                    </div>
                                </div>

                                <div
                                    class="attendance-card"
                                    v-if="additionals"
                                >   
                                    <div class="attendance-item">
                                        <span>Data atendimento</span>
                                        <strong>{{ additionals.dataAtendimento }}</strong>
                                    </div>

                                    <div class="attendance-item">
                                        <span>Hora início</span>
                                        <strong>{{ additionals.horaInicioAtendimento }}</strong>
                                    </div>

                                    <div class="attendance-item">
                                        <span>Demanda</span>

                                        <strong>
                                            {{ additionals.isDemandaEspontanea ? 'Espontânea' : 'Programada' }}
                                        </strong>
                                    </div>

                                    <div class="attendance-time">
                                        {{ tempoAtendimento }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <rkm-layout-content :no-card-style="form && !form.paciente.isIdoso">
                    <Form
                        :agendamento-id="agendamentoId"
                        :fila-id="filaId"
                        :ficha-avaliacao="fichaAvaliacao"
                        @loaded="loaded"
                        @saved="saved"
                        :tempoAtendimento="tempoAtendimento"
                        ref="Form"
                    />
                </rkm-layout-content>
            </rkm-layout-body>

            <ModalPacienteTelefone ref="ModalPacienteTelefone" />
        </template>

        <template v-else>
            <rkm-layout-body title="Atendimento">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>CONSULTÓRIO</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/ambulatorio/atendimento/Form'
import ModalPacienteTelefone from '@/components/ambulatorio/components/paciente/telefone/Modal'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        Form,
        ModalPacienteTelefone,
    },
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
        disableSaveDraftButton() {
            return this.model && (this.model.soap.finalizacao.desfecho.finalizado === true || this.model.soap.finalizacao.desfecho.finalizado === 'encaminhar')
        },
        isRetroativo() {
            return this.filaId === 0
        },
    },
    created() {
        this.setShowExitFormConfirmation()

        this.repositories = {
            fila: this.getConectaSusRepository('ambulatorio.fila'),
        }
    },
    beforeDestroy() {
        clearInterval(this.timerInterval)
    },
    data: () => ({
        enums: {setorTipo},
        additionals: null,
        form: null,
        model: null,
        tempoAtendimento: '00:00:00',
        timerInterval: null,
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'setShowExitFormConfirmation',
            'unsetLoading',
            'unsetShowExitFormConfirmation',
        ]),
        redirectToList() {
            this.unsetShowExitFormConfirmation()
            this.$router.push('/ambulatorio/atendimento/index')
        },
        loaded(value) {
            this.additionals = value.additionals
            this.form = value.form
            this.model = value.model

            if(value.form.finalizadoEm){
                this.redirectToList()
            }

            this.$nextTick(() => this.startTimer())
        },
        startTimer() {
            clearInterval(this.timerInterval)
            const dbValue = this.model?.soap?.tempoAtendimento

            let baseSeconds = 0
            
            if (dbValue) {
                if (typeof dbValue === 'number') {
                    baseSeconds = dbValue
                } else {
                    const parts = String(dbValue).split(':').map(Number)
                    if (parts.length === 3) baseSeconds = parts[0] * 3600 + parts[1] * 60 + parts[2]
                    else if (parts.length === 2) baseSeconds = parts[0] * 60 + parts[1]
                }
            }

            const pageLoad = Date.now()

            const tick = () => {
                const elapsed = baseSeconds + Math.floor((Date.now() - pageLoad) / 1000)
                const hh = Math.floor(elapsed / 3600)
                const mm = Math.floor((elapsed % 3600) / 60)
                const ss = elapsed % 60
                this.tempoAtendimento = [hh, mm, ss].map(v => String(v).padStart(2, '0')).join(':')
            }

            tick()
            this.timerInterval = setInterval(tick, 1000)
        },
        saved() {
            this.redirectToList()
        },
        exit() {
            this.showExitConfirmation(async () => {
                if (this.isRetroativo || this.additionals.isRascunho) {
                    this.redirectToList()
                } else {
                    this.setLoading()
                    return this.repositories.fila.sendBack(this.filaId)
                        .then(() => this.redirectToList())
                        .finally(() => this.unsetLoading())
                }
            }, this.handleError)
        },
    },
    mixins: [error, repository],
    props: {
        filaId: {type: Number, required: true},
        agendamentoId: {type: Number},
        fichaAvaliacao: {type: Boolean, default: true},
    },
}
</script>

<style scoped>
.sub-title {
    color: #222;
    font-size: 14px;
    text-transform: none !important;
}

.sub-title-link {
    font-size: 14px;
    text-transform: none !important;
    text-align: top;
    height: auto;
    margin-bottom: 3px;
    padding: 0;
}

.sub-title-nome {
    font-size: 18px;
}

.acompanhamento-idoso {
    color: #155724;
}

.acompanhamento-gestante {
    color: #ffb6c1;
}

.acompanhamento-hipertenso,
.acompanhamento-diabetico {
    color: #856404;
}

.acompanhamento-saude-mulher {
    color: #b34db2;
}

.acompanhamento-crescimento-desenvolvimento-infantil {
    color: #004085;
}

.patient-header {
    position: sticky;
    top: 116px;
    z-index: 996;
    margin: -15px -15px 0 -15px;
    padding: 5px 15px;
    background: #f8fafc;
}

.patient-main-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 12px;
    width: 100%;
    box-shadow: 0 1px 6px rgba(0, 0, 0, .05);
}

::v-deep .layout-body-subtitle {
    width: 100%;
    max-width: unset !important;
}

.patient-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
}

.patient-content {
    flex: 1;
    min-width: 0;
}

.patient-name-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.patient-name {
    font-size: 26px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    line-height: 1.1;
}

.patient-real-name {
    color: #6b7280;
    font-size: 13px;
}

.badge-social {
    background: #ede9fe;
    color: #6d28d9;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
}

.patient-tags {
    display: flex;
    gap: 6px;
    margin-top: 2px;
    flex-wrap: wrap;
}

.info-chip {
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    padding: 4px 10px;
    font-size: 11px;
    color: #374151;
    font-weight: 600;
}

.patient-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 10px;
    margin-top: 10px;
}

.info-block {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-left: 3px solid #1565c0;
    border-radius: 8px;
    padding: 6px 10px;
    min-height: 52px;

    display: flex;
    flex-direction: column;
    justify-content: center;
}

.info-block label {
    margin: 0;
    font-size: 10px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: .5px;
    line-height: 1.1;
}

.info-block span,
.info-block div {
    margin-top: 2px;
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    line-height: 1.3;
}

.attendance-card {
    flex-shrink: 0;
    min-width: 240px;
    background: linear-gradient(
        135deg,
        #1976d2,
        #1565c0
    );
    color: white;
    border-radius: 12px;
    padding: 14px;
    min-height: 125px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 4px 12px rgba(21, 101, 192, .25);
}

.attendance-title {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .8px;
    opacity: .85;
    font-weight: 700;
}

.attendance-item {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    font-size: 12px;
}

.attendance-item span {
    opacity: .85;
}

.attendance-item strong {
    font-weight: 600;
}

.attendance-time {
    margin-top: 6px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    letter-spacing: 1px;
}

.health-flags {
    margin-top: 9px;
    padding-top: 2px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    border-top: 1px solid #e5e7eb;
}

.health-title {
    font-size: 12px;
    color: #6b7280;
    font-weight: 600;
}

.health-badge {
    padding: 5px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
}
</style>
